import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'text',
        name: 'name',
        title: 'Depo Adı',
        rules: {required: true},
        modal: ['name'],
        data: ['name'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'radio',
        name: 'status',
        title: 'Durum',
        default: true,
        rules: {required: true},
        options: {
            type: 'locale',
            data: [
                {text: 'Aktif Depo', value: true},
                {text: 'Pasif Depo', value: false},
            ],
        },
        modal: ['is_active'],
        data: ['is_active'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'radio',
        name: 'type',
        title: 'Stok Takibi',
        default: true,
        rules: {required: true},
        options: {
            type: 'locale',
            data: [
                {text: 'Takip Edilecek', value: false},
                {text: 'Takip Dışı', value: true},
            ],
        },
        modal: ['is_technical'],
        data: ['is_technical'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'textarea',
        name: 'address',
        title: 'Adres',
        rules: {required: false},
        modal: ['address'],
        data: ['address'],
        additionalButton: false,
        checkBox: false
    },
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/ERP/Warehouse/forms/warehouse.js